import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function OutstationToPuneLinks() {
  const [showLinks, setShowLinks] = useState(false);

  const toggleLinks = (e) => {
    e.preventDefault(); // Prevent page reload
    setShowLinks(!showLinks);
  };

  return (
    <div>
      <a
        href=""
        className="outstation-link mx-md-2"
        onClick={toggleLinks}
      >
        <i className=" darkcolo"></i> Outstation to Pune Cabs
      </a>

      {showLinks && (
        <div className="outstation- mt-2">
          <Link className="mx-md-2 darkcoloo d-block" to="/Jogeshwari-to-Pune-Cab-Service"><i className="fa fa-car darkcolo"></i> Jogeshwari to Pune Cab Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Goregaon-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Goregaon to Pune Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Kandivali-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Kandivali to Pune Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Vile-Parle-to-Pune-Cab-Service"><i className="fa fa-car darkcolo"></i> Vile Parle to Pune Cab Service</Link>

          <Link className="mx-md-2 darkcoloo d-block" to="/Bhandup-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Bhandup to Pune Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Ghatkopar-to-Pune-Cab-Service"><i className="fa fa-car darkcolo"></i> Ghatkopar to Pune Cab Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Kurla-to-Pune-Taxi-Service"><i className="fa fa-car darkcolo"></i> Kurla to Pune Taxi Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Powai-Mumbai-Pune-Cab-Service"><i className="fa fa-car darkcolo"></i> Powai Mumbai Pune Cab Service</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Chembur-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Chembur to Pune Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Terminal-1-2-3-Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Terminal 1, 2, 3 Mumbai Airport to Pune Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Thane-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Thane to Pune Cab</Link>
          <Link className="mx-md-2 darkcoloo d-block" to="/Vikhroli-to-Pune-Cab-Services"><i className="fa fa-car darkcolo"></i> Vikhroli to Pune Cab Services</Link>
       
       
               <Link className="mx-md-2 darkcoloo d-block" to="/Panvel-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Panvel to Pune Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Church-Gate-to-Pune-Cab-Service"><i className="fa fa-car darkcolo"></i> Church Gate to Pune Cab Service</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Byculla-to-Pune-Cab-Service"><i className="fa fa-car darkcolo"></i> Byculla to Pune Cab Service</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Vashi-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Vashi to Pune Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Kharghar-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Kharghar to Pune Cab</Link>
                               <Link className="mx-md-2 darkcoloo d-block" to="/Mankhurd-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Mankhurd to Pune Cab</Link>
                            {/* <Link className="mx-md-2 darkcoloo" to="/Mumbai-to-Pune-Innova-Crysta-Cab"><i className="fa fa-car darkcolo"></i> Mumbai to Pune Innova Crysta Cab</Link> */}
                              <Link className="mx-md-2 darkcoloo d-block" to="/Santacruz-to-Pune-Cab"><i className="fa fa-car darkcolo"></i> Santacruz to Pune Cab</Link>
                               
        </div>
      )}
    </div>
  );
}

export default OutstationToPuneLinks;
